
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/editorial-statute",
      function () {
        return require("private-next-pages/editorial-statute.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/editorial-statute"])
      });
    }
  